import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import initStore from '../store';
import { SidebarProvider } from '../context/SidebarContext';

const store = initStore();

const Layout = ({ children }) => {
  return (
    <Provider store={store}>
      <SidebarProvider>
        {children}
      </SidebarProvider>
    </Provider>
  );
};
Layout.propTypes = {
  children: PropTypes.node,
};
export default Layout;
